import React from "react";
import { useParams } from "react-router-dom";
import { apiCallPost, indianRupee, niceDate, niceDateTime } from "../util/util";
import "../PurchaseOrder.css";
import QRCode from "react-qr-code";
import {
  Button,
  H3,
  H4,
  H5,
  H6,
  NonIdealState,
  Spinner,
} from "@blueprintjs/core";
import cogoToast from "cogo-toast";

function withRouter(Component) {
  function ComponentWithRouter(props) {
    let params = useParams();
    return <Component {...props} params={params} />;
  }
  return ComponentWithRouter;
}

class POLowerOrder extends React.Component {
  state = { isLoading: true, isFailure: false, poId: null, hasLoaded: false };
  componentDidMount() {
    let ss = this.props.params.poId;
    this.setState({ poId: ss });
    if (ss) {
      this.getSubmission(ss);
    } else {
      this.setState({ isLoading: false, isInvalid: true });
    }
  }
  getSubmission = async (ss) => {
    try {
      let res = await apiCallPost("/print/ims2PurchaseOrder", {
        poId: ss,
      });
      this.setState({ isLoading: false, hasLoaded: true, ...res }, () => {
        this.addTerms();
        document.title = `${this.state.entityName} - ${this.state.branchInfo.hospital_name}`;
      });
    } catch (err) {
      cogoToast.error("Failed to load purchase order data.");
      this.setState({ isLoading: false, isFailure: true });
    }
  };
  addTerms = () => {
    let addlTerms = [
      {
        tncText:
          "Prices above are all-inclusive and no other charges (delivery, labour or others) will be borne.",
      },
      {
        tncText:
          "Prices mentioned are considered final unless explicitly mentioned otherwise.",
      },
      {
        tncText: `Delivery or service timeline is to be strictly adhered to. ${
          this.state.needBy
            ? `Items or services in this order must be received and accepted by ${niceDate(
                this.state.needBy
              )}.`
            : ""
        }`,
      },
      {
        tncText:
          "The purchaser will inspect and audit the goods or services on delivery, and is not liable for damage, loss or deterioration prior to acceptance.",
      },
      {
        tncText: `All invoices must contain the purchase order ID ${
          this.state.entityName
        } and date ${niceDate(this.state.updatedAt)}.`,
      },
    ];
    this.setState({ tncs: [...this.state.tncs, ...addlTerms] });
  };
  renderHeader = () => {
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                marginRight: "5px",
                marginBottom: "5px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                alt="Client Logo"
                src={this.state.branchInfo.logoUrl}
                height="85px"
                width="auto"
                className="img_block"
              />
              <b
                style={{
                  fontSize: "9pt",
                  marginTop: "3px",
                  maxWidth: "120px",
                  textAlign: "center",
                }}
              >
                {this.state.branchInfo.hospital_name}
              </b>
            </div>
            <div>
              <div style={{ textAlign: "left" }}>
                {this.renderHorizontalText(
                  this.state.isServiceOrder
                    ? "SERVICE ORDER FROM"
                    : "PURCHASE ORDER FROM"
                )}
              </div>
              <b> {this.state.billBranchInfo.hospital_contact[0]}</b> <br />
              {this.state.billBranchInfo.hospital_contact[1]} <br />
              {this.state.billBranchInfo.hospital_contact[2]} <br />
              {this.state.billBranchInfo.hospital_contact[3]} <br />
            </div>
          </div>{" "}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
              textAlign: "right",
              marginRight: "10px",
            }}
          >
            <div
              style={{
                marginLeft: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                justifyContent: "space-between",
                textAlign: "right",
                maxWidth: "200px",
              }}
            >
              <div>
                <H4>
                  {this.state.isServiceOrder
                    ? "Service Order"
                    : "Purchase Order"}
                </H4>{" "}
                <H3>{this.state.entityName}</H3>
              </div>

              <div>{niceDateTime(this.state.updatedAt)}</div>
            </div>
            <div
              style={{
                marginLeft: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <QRCode
                size={80}
                value={`https://print.newchart.care/po/${this.props.params.poId}`}
                level="H"
              />
              <div
                style={{
                  fontSize: "x-small",
                  wordBreak: "break-all",
                  maxWidth: "150px",
                  textAlign: "center",
                }}
              >
                <code> {this.state.poId}</code>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  renderVendorAndReceivingRow = () => {
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                marginRight: "5px",
                marginBottom: "5px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                maxWidth: "40vw",
              }}
            >
              <div>
                {this.renderHorizontalText(
                  this.state.isServiceOrder
                    ? "SERVICE ORDER TO"
                    : "PURCHASE ORDER TO"
                )}
              </div>{" "}
              <H5>{this.state.vendorName}</H5>
              <div>{this.state.legal_name_of_business}</div>
              <div>{this.state.principal_place_address}</div>
              <div>
                {this.state.GSTIN
                  ? `GSTIN: ${this.state.GSTIN}`
                  : "No GSTIN Recorded"}
              </div>
              <div>{this.renderContacts(this.state.vendorContacts)}</div>
            </div>
          </div>{" "}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                marginRight: "5px",
                marginBottom: "5px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                justifyContent: "flex-start",
                maxWidth: "40vw",
              }}
            >
              <div>
                {this.renderHorizontalText(
                  this.state.isServiceOrder
                    ? "SERVICE LOCATION"
                    : "DELIVERY LOCATION"
                )}
              </div>
              <H5>
                {this.state.recvLocation.branchName} | Store:{" "}
                {this.state.recvLocation.branchStoreName}
              </H5>
              <H6>Needed By: {niceDate(this.state.needBy)}</H6>
              <div>{this.state.recvLocation.branchShippingAddress}</div>
              <div>
                {this.renderContacts(this.state.recvLocation.branchContacts)}
              </div>
            </div>
          </div>{" "}
        </div>
      </div>
    );
  };
  renderContacts = (list) => {
    if (!list) {
      return null;
    }
    if (!list.length) {
      return null;
    }
    return list.map((each, index) => {
      return (
        <div>
          Contact {index + 1}: {each.name} - {each.phone} - {each.email}
        </div>
      );
    });
  };
  renderItems = () => {
    return (
      <div>
        <div>{this.renderHorizontalText("ITEMS")}</div>
        <table
          className="bp4-html-table bp4-html-table-condensed bp4-html-table-bordered bp4-html-table-striped"
          style={{ marginLeft: "auto", marginRight: "auto", width: "90vw" }}
        >
          <thead>
            <tr>
              <th>#</th>
              <th>Item</th>
              <th>Price</th>
              <th>GST</th>
              <th>Quantity</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {this.renderEachItem()}

            <tr>
              <td colSpan={5} style={{ textAlign: "right" }}>
                <b> Total</b>
              </td>
              <td>
                <b>{indianRupee(this.renderTotal())}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };
  renderTotal = () => {
    let total = 0;
    if (!this.state.items) {
      return total;
    }
    if (!this.state.items.length) {
      return total;
    }
    for (var i = 0; i < this.state.items.length; i++) {
      total +=
        (this.state.items[i].price +
          (this.state.items[i].price * this.state.items[i].gst) / 100) *
        this.state.items[i].quantity;
    }
    return total;
  };
  renderTermsAndFooter = () => {
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                marginRight: "5px",
                marginBottom: "5px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                maxWidth: "40vw",
              }}
            >
              <div>{this.renderTerms()}</div>
              <div>{this.renderEachTerm()}</div>
            </div>
          </div>{" "}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                marginRight: "5px",
                marginBottom: "5px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                justifyContent: "flex-start",
                maxWidth: "40vw",
              }}
            >
              <div style={{ textAlign: "right" }}>
                {this.renderHorizontalText("E. & O. E.")}
              </div>
              <div style={{ textAlign: "right" }}>
                This is a computer generated purchase order and does not require
                a signature.
              </div>
              <div style={{ textAlign: "right" }}>
                In case of queries, please reach out to us.
              </div>
              <div style={{ textAlign: "right" }}>
                This order shall be governed by and construed in accordance with
                laws applicable in India and any arbitration will be resolved in
                the jurisdiction of the state of West Bengal.
              </div>
            </div>
          </div>{" "}
        </div>
      </div>
    );
  };
  renderTerms = () => {
    if (!this.state.tncs) {
      return null;
    }
    if (!this.state.tncs.length) {
      return null;
    }
    return <div>{this.renderHorizontalText("TERMS AND CONDITIONS")}</div>;
  };
  renderEachTerm = () => {
    if (!this.state.tncs) {
      return null;
    }
    if (!this.state.tncs.length) {
      return null;
    }
    return this.state.tncs.map((each, index) => {
      return (
        <div>
          {index + 1}. {each.tncText}
        </div>
      );
    });
  };
  renderEachItem = () => {
    if (!this.state.items) {
      return null;
    }
    if (!this.state.items.length) {
      return null;
    }
    return this.state.items.map((each, index) => {
      return (
        <tr>
          <td>{index + 1}</td>
          <td>{each.itemName}</td>
          <td>{indianRupee(each.price)}</td>
          <td>{each.gst}%</td>
          <td>{each.quantity}</td>

          <td>
            {indianRupee(
              (each.price + (each.price * each.gst) / 100) * each.quantity
            )}
          </td>
        </tr>
      );
    });
  };
  renderVerticalText = (text, isProminent = true) => {
    return (
      <div
        style={{
          textAlign: "center",
          backgroundColor: "#E6E7E7",
          textOrientation: "upright",
          writingMode: "vertical-rl",
          marginRight: "10px",
          fontSize: "xx-small",
          border: `${isProminent ? "1px solid black" : ""}`,
        }}
      >
        {isProminent ? <b>{text}</b> : <>{text}</>}
      </div>
    );
  };
  renderHorizontalText = (text, isProminent = false) => {
    return (
      <div
        style={{
          textAlign: "center",
          backgroundColor: "#E6E7E7",
          marginBottom: "10px",
          fontSize: "xx-small",
          letterSpacing: "1mm",

          border: `${isProminent ? "1px solid black" : ""}`,
        }}
      >
        {isProminent ? <b>{text}</b> : <>{text}</>}
      </div>
    );
  };

  render() {
    if (this.state.isLoading) {
      return (
        <div className="center_screen">
          <NonIdealState icon={<Spinner />} title="Loading..." />
        </div>
      );
    }
    if (this.state.isFailure) {
      return (
        <div className="center_screen">
          <NonIdealState
            icon="warning-sign"
            title="We ran into an error. If you face this problem multiple times, please contact support."
          />
        </div>
      );
    }
    if (!this.state.hasLoaded) {
      return (
        <div className="center_screen">
          <NonIdealState
            icon="warning-sign"
            title="We ran into an error. If you face this problem multiple times, please contact support."
          />
        </div>
      );
    }
    return (
      <div
        className="rx__container"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {" "}
        <style type="text/css" media="print">
          {" @page { size: A4 portrait !important; margin: 7mm !important;"}
        </style>
        <div>
          <div className="no__print">
            <Button
              icon="print"
              text="Print"
              onClick={() => {
                window.print();
              }}
              fill
            />{" "}
            <br />
            <br />
          </div>
          {this.renderHeader()}
          <hr />
          {this.renderVendorAndReceivingRow()}
          <hr />
          {this.renderItems()}
        </div>
        <div style={{ width: "100vw" }}>
          <hr />
          {this.renderTermsAndFooter()}
        </div>
      </div>
    );
  }
}

const PurchaseOrder = withRouter(POLowerOrder);
export default PurchaseOrder;
